import React, { useContext, useState, useEffect } from 'react';
import {
  Avatar,
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  Select,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import bell from '../../public/icons/bell.svg';
import IsDesktop from '../../utils/IsDesktop';
import { UserContext } from '../../context/UserContext';
import useData from '../../data/useData';
import Notifications from '../notification/Notifications';
import { useDispatch, useSelector } from 'react-redux';
import UserService from '../../utils/UserService';
import { setTotalNotificationCount, setUnreads, setUserSubscriptionInfo } from '../../redux-toolkit/reducers/userSlice';
import { useNavigate } from 'react-router-dom';
import { setCompanyInfo } from '../../redux-toolkit/reducers/companySlice';
import { BsFillCaretDownFill } from 'react-icons/bs';
import { ArrowUpIcon } from '@chakra-ui/icons';
import ProfileIcon from '../../public/icons_v2/user.svg';
import SettingsIcon from '../../public/icons_v2/setting.svg';
import MessageIcon from '../../public/icons_v2/message-question.svg';
import LogoutIcon from '../../public/icons_v2/logout.svg';
import CustomerSupportModal from '../modal/CustomerSupportModal';
import LogoutModal from '../modal/LogoutModal';
import SearchBar from '../searchbar/SearchBar';
import { useQueryClient } from 'react-query';
import { useMutation, mutateFunction } from '../../libs/apis';
import { CustomToast } from '../toast/CustomToast';
import client from '../../libs/client';
import {
  Plans,
  SelectedPlan,
  ThankYouPage,
  PaymentFailedPage,
} from '../modal/SubscriptionPlansModal';
import { setSubscriptionPlans } from '../../redux-toolkit/reducers/userSlice';

const Header = ({ title, component }) => {
  const loggedInUser = useSelector((state) => state?.user?.userInfo);
  const [subTitle, setSubTitle] = useState('');
  const companyDetails = useSelector((state) => state?.company?.companyInfo);
  const expertDetails = useSelector((state) => state?.expert?.expertInfo);
  const loggedInUserSubscription = useSelector(
    (state) => state?.user?.userSubscriptionInfo,
  );


  const totalNotificationCount = useSelector(
    (state) => state?.user?.totalNotificationCount,
  );
  const allCompaniesInfo = useSelector(
    (state) => state?.allcompanies?.allCompaniesInfo || [],
  );
  const loggedInUserType = loggedInUser?.userTypeTitle || '';
  const dispatch = useDispatch();
  const isDesktop = IsDesktop();
  const { userInformation } = useContext(UserContext);
  const { isOpen, onToggle } = useDisclosure();
  const [page, setPage] = useState(0);
  const loggedInUserId = loggedInUser?.id || '';
  const loggedInUserStatus = loggedInUser?.status || '';
  const navigate = useNavigate();
  const accountInformationStatus =
    loggedInUserType === 'admin' || loggedInUserType === 'sub_admin'
      ? loggedInUserType
      : loggedInUserType === 'expert'
        ? expertDetails?.status
        : companyDetails?.status;
  const [selectedPlan, setSelectedPlan] = useState({});
  const [selectedPackage, setSelectedPackage] = useState();
  const { isOpen: isOpenNotifications, onToggle: onToggleNotifications } =
    useDisclosure();
  const { isOpen: isLogoutModalOpen, onToggle: onToggleLogoutModal } =
    useDisclosure();

  const urlParams = new URLSearchParams(window.location.search);
  const success = urlParams.get('success');
  const planName = urlParams.get('plan_name');
  const upgrade = urlParams.get('upgrade');

  const SUBSCRIPTION_FLAG = process.env.REACT_APP_SUBSCRIPTION_FLAG;

  const subscriptionPlans = useSelector((state) => state?.user?.subscriptionPlans);

  const { mutate: checkSubscriptionPlan, isLoading: isCheckingSubscriptionPlan } = useMutation(mutateFunction);

  const getSubscriptionPlans = async () => {
    if (loggedInUser?.userTypeId) {
      try {
        const response = await client().get('subscription/plans?user_type_id=' + loggedInUser?.userTypeId);
        return response.data;
      } catch (error) {
        console.error('Error fetching subscription plans:', error);
        throw error;
      }
    }
  };


  const getCurrentPlan = async () => {
    try {
      const response = await client().get(`users/${loggedInUserId}/subscriptions/current`);
      return response.data;
    } catch (error) {
      console.error('Error fetching current plan:', error);
      throw error;
    }
  };


  useEffect(() => {
    const fetchPlans = async () => {
      if (!subscriptionPlans) {
        try {
          const plans = await getSubscriptionPlans();
          dispatch(setSubscriptionPlans(plans));
        } catch (error) {
          console.error('Failed to fetch subscription plans:', error);
        }
      }
    };

    fetchPlans();
  }, [subscriptionPlans, dispatch]);



  useEffect(() => {
    const fetchCurrentPlan = async () => {
      const currentPlan = await getCurrentPlan();

      if (
        currentPlan?.currentSubscription?.currentSubscription?.subscription_plan?.name != loggedInUserSubscription?.subscription_plan?.name ||
        currentPlan?.currentSubscription?.currentSubscription?.auto_renew != loggedInUserSubscription?.auto_renew
      ) {
        dispatch(setUserSubscriptionInfo(currentPlan?.currentSubscription?.currentSubscription));
        UserService.setUserSubscriptionInfo(currentPlan?.currentSubscription?.currentSubscription);
      }
    };


    if (SUBSCRIPTION_FLAG == "on") {
      fetchCurrentPlan();
    }

  }, [])


  const { data: NotificationData, refetch: refetchNotification } = useData(
    `users/${loggedInUserId}/notification?page_no=1&page_size=10`,
    0,
  );

  const {
    isOpen: isDropdownOpen,
    onClose: onCloseDropdown,
    onToggle: onToggleDropdown,
  } = useDisclosure();

  const {
    isOpen: submitComplaintModalIsOpen,
    onOpen: onOpenSubmitComplaintModal,
    onClose: onCloseSubmitComplaintModal,
  } = useDisclosure();

  const queryClient = useQueryClient();
  const { addToast } = CustomToast();
  const { mutate: resumeSubscription, isLoading: isResuming } = useMutation(mutateFunction);
  const { mutate: manageSubscription, isLoading: isCancelling } = useMutation(mutateFunction);



  useEffect(() => {
    if (loggedInUserType === 'expert') {
      setSubTitle('Find founders to support and collaborate with');
    } else if (loggedInUserType === 'investor') {
      setSubTitle('Discover founders and explore your investment portfolio');
    } else if (loggedInUserType === 'founder') {
      setSubTitle(
        'Connect with experts and discover resources to build your venture',
      );
    }
  }, [loggedInUserType]);

  // Check URL parameters for payment success/failure
  useEffect(() => {
    if (success === 'false' && planName) {
      setPage(3); // Page 3 for failure
      if (!selectedPlan?.name) {
        setSelectedPlan(subscriptionPlans?.data?.find(plan => plan?.name === planName));
      }

      if (!isOpen) {
        onToggle(); // Open the modal
      }

    } else if (success === 'true' && planName) {
      setPage(2); // Page 2 for success
      if (!selectedPlan?.name) {
        setSelectedPlan(subscriptionPlans?.data?.find(plan => plan?.name === planName));
      }

      if (!isOpen) {
        onToggle(); // Open the modal
      }
    } else if (upgrade === 'true') {
      setPage(0);
      if (!isOpen) {
        onToggle();
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, [window.location.search]);



  // const [allConnections, setAllConnections] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);


  const upgradeUser = (plan) => {
    setSelectedPlan(plan);
    setPage(page + 1);
  };

  const toggleNotifications = () => {
    if (loggedInUserStatus == 'disabled') return;
    onToggleNotifications();
  };

  const [currentCompanyIndex, setCurrentCompanyIndex] = useState(0);

  const onChangeCurrentCompanyIndex = (e) => {
    setCurrentCompanyIndex(e.target.value);
    dispatch(setCompanyInfo(allCompaniesInfo[Number(e.target.value)]));
    UserService.setCompanyInfo(allCompaniesInfo[Number(e.target.value)]);
  };

  useEffect(() => {
    let index = allCompaniesInfo.findIndex(
      ({ id }) => id === companyDetails?.id,
    );
    index >= 0 && setCurrentCompanyIndex(`${index}`);
  }, [companyDetails?.title]);

  useEffect(() => {
    const data = NotificationData?.data?.notifications;
    if (NotificationData) {
      setNotifications(data);
    }

    if (UserService.getNotificationCurrentCount() > data?.length) {
      UserService.setNotificationCurrentCount(data?.length);
    }
  }, [NotificationData]);

  useEffect(() => {
    if (notifications && notifications?.length > 0) {
      const unreadNotificationsCount = notifications?.filter(
        (notification) => notification.read === false,
      )?.length;


      dispatch(setTotalNotificationCount(unreadNotificationsCount))


      let _messageTracker = {};
      for (let _item of notifications) {
        const { type, senderId, id } = _item

        if (type == 'message') {
          let { count = 0, ids = [], senderIds = [] } = _messageTracker[senderId] || {};
          count += 1;
          ids = [...ids, id];
          senderIds = [...senderIds, senderId];
          _messageTracker[senderId] = {
            count,
            ids,
            senderIds
          };
        }
      }

      const _unreads = Object.keys(_messageTracker)
      if (_unreads.length > 0) {
        dispatch(setUnreads(_messageTracker))
      } else {
        dispatch(setUnreads(null))
      }
    } else {
      dispatch(setTotalNotificationCount(0))
    }
  }, [notifications]);


  const checkout = () => {
    if (!selectedPackage) {
      return;
    } else {
      const currentUrl = window.location.href;

      checkSubscriptionPlan(
        {
          key: `subscription/stripe/checkout`,
          method: 'post',
          data: {
            plan_id: selectedPlan?.id,
            success_url: `${currentUrl}?success=true&plan_name=${selectedPlan?.name}`,
            cancel_url: `${currentUrl}?success=false&plan_name=${selectedPlan?.name}`,
          },
        },
        {
          onSuccess: (response) => {
            if (response?.data?.url) {
              window.location.href = response.data.url;
            }
          },
          onError: (error) => {
            setPage(3);
            addToast({
              message: error?.response?.data?.message || 'Payment processing failed. Please try again.',
              type: 'error',
            });
          },
        },
      );
    }
  };

  const handleRetry = () => {
    // Ensure selectedPlan is set before navigating to checkout page
    if (!selectedPlan || !selectedPlan?.name) {
      const urlParams = new URLSearchParams(window.location.search);
      const planName = urlParams.get('plan_name');
      if (planName && subscriptionPlans?.data) {
        const plan = subscriptionPlans.data.find(p => p?.name === planName);
        if (plan) {
          setSelectedPlan(plan);
        }
      }
    }
    setPage(1);
  };

  const closePlanModal = () => {
    // Clean up URL parameters
    window.history.replaceState({}, document.title, window.location.pathname);

    setPage(0);
    onToggle();
  };

  const viewDetails = () => {
    navigate(
      `/view-user?userid=${loggedInUser?.id}&usertype=${loggedInUser?.userTypeId}`,
    );
    window.scrollTo(0, 0);
  };

  const selectPackage = (pack) => {
    setSelectedPackage(pack);
  };

  const updateSubscriptionInfo = async () => {
    try {
      const response = await client().get(`users/${loggedInUserId}/subscriptions/current`);
      const updatedSubscription = response?.data?.currentSubscription?.currentSubscription;
      dispatch(setUserSubscriptionInfo(updatedSubscription));
      UserService.setUserSubscriptionInfo(updatedSubscription);
    } catch (error) {
      console.error('Error fetching updated subscription:', error);
    }
  };

  const handleCancelClick = () => {
    manageSubscription(
      {
        key: 'subscription/manage',
        method: 'post',
        data: {
          return_url: window.location.href,
        }
      },
      {
        onSuccess: (res) => {
          window.location.href = res?.data?.url;
        },
        onError: (err) => {
          addToast({
            message: err?.response?.data?.message || 'Failed to manage subscription. Please try again.',
            type: 'error',
          });
        }
      }
    );
  };


  const handleResumeSubscription = () => {
    if (!loggedInUserId) return;

    resumeSubscription(
      {
        key: "subscription/resume",
        method: 'post',
      },
      {
        onSuccess: async (res) => {
          addToast({
            message: res?.message || 'Subscription resumed successfully.',
            type: 'success',
          });

          updateSubscriptionInfo();
          closePlanModal();
        },
        onError: (err) => {
          addToast({
            message: err?.response?.data?.message || 'Failed to resume subscription. Please try again.',
            type: 'error',
          });
        },
      },
    );
  };



  const ClickNotification = () => {
    const unreadNotificationsCount = notifications?.filter(
      (notification) => notification.read === false,
    )?.length;

    UserService.setNotificationCurrentCount(unreadNotificationsCount);
    dispatch(setTotalNotificationCount(unreadNotificationsCount))
    toggleNotifications();
  };

  const allowUserSubscription = (loggedInUserType == "founder" || loggedInUserType == "investor") && SUBSCRIPTION_FLAG == "on" && !!subscriptionPlans;

  return (
    <Box
      w="100%"
      className={`${!isDesktop ? 'fixed top-0 flex items-center z-10 bg-[#F6F6F6]' : 'bg-white'}`}
    >
      {loggedInUserStatus == 'disabled' ? (
        <Flex
          _hover={{ backgroundColor: '#c68e8e' }}
          className={`${!isDesktop ? 'fixed' : ''} justify-center text-xs lg:text-sm bg-red-200 w-full text-center`}
        >
          This account is currently disabled
        </Flex>
      ) : accountInformationStatus === 'draft' ? (
        <Flex
          _hover={{ backgroundColor: '#c68e8e' }}
          onClick={() => {
            navigate('/account-settings');
          }}
          className={`${!isDesktop ? 'fixed top-0' : ''} justify-center cursor-pointer text-xs lg:text-sm bg-red-200 w-full text-center`}
        >
          {`Your account is in draft mode.${isDesktop && loggedInUserType !== 'founder'
            ? ` Click to update ${loggedInUserType === 'expert' ? 'expert' : 'company'
            } details`
            : ' Click to complete your profile and become Deal Ready.'
            }`}
        </Flex>
      ) : null}
      {isOpenNotifications ? (
        <Notifications
          isOpen={isOpenNotifications}
          onClose={() => {
            refetchNotification();
            onToggleNotifications();
          }}
        />
      ) : (
        <></>
      )}
      <Flex
        h="100%"
        w="full"
        justifyContent="space-between"
        alignItems="center"
        //boxShadow="0px 10px 20px rgba(0, 0, 0, 0.05)"
        px={5}
        py={5}
      >
        {isDesktop && (
          <Box>
            <Text color="#134A70" className="capitalize text-3xl font-semibold">
              {loggedInUserType !== 'admin' || loggedInUserType !== 'sub_admin'
                ? `${userInformation?.firstName}, ${loggedInUserType}`
                : loggedInUserType}
            </Text>
            <Text className="text-sm text-black">{subTitle}</Text>
          </Box>
        )}
        <Flex
          alignItems="center"
          className={`justify-end gap-5 ${!isDesktop ? 'w-full' : ''}`}
        >
          <Text
            mr={2}
            color="#000"
            textTransform="capitalize"
            fontWeight={600}
            fontSize="16px"
          >
            {loggedInUserType == 'founder' ? (
              <Box className={`md:flex hidden flex-col gap-1`}>
                <Select
                  className="w-[220px]"
                  value={currentCompanyIndex}
                  onChange={onChangeCurrentCompanyIndex}
                  placeholder={''}
                >
                  {allCompaniesInfo.map((_company, index) => (
                    <option key={index} value={index}>
                      {_company.title}
                    </option>
                  ))}
                </Select>
              </Box>
            ) : null}
          </Text>
          {allowUserSubscription && isDesktop ? (
            <Button mr={6} onClick={() => onToggle()}>
              Upgrade
            </Button>
          ) : (
            <></>
          )}
          <SearchBar />
          <div
            style={{ position: 'relative', cursor: 'pointer' }}
            onClick={ClickNotification}
          >
            <Image cursor="pointer" w={'26px'} src={bell} alt="bell-icon" />
            {totalNotificationCount > 0 && (
              <div
                style={{
                  background: '#CF1137',
                  top: '-5px',
                  right: '-3px',
                  color: '#fff',
                }}
                className="absolute text-[10px] font-semibold flex items-center justify-center border border-white rounded-full h-5 w-5"
              >
                {totalNotificationCount}
              </div>
            )}
          </div>
          <>
            <Menu>
              <MenuButton aria-label="Options">
                <Box
                  onClick={onToggleDropdown}
                  className="flex gap-1 cursor-pointer items-center"
                >
                  <Avatar
                    w={'40px'}
                    h={'40px'}
                    name={`${userInformation?.firstName} ${userInformation?.lastName}`}
                    src={userInformation?.profile_image}
                  />
                  <BsFillCaretDownFill />
                </Box>
              </MenuButton>
              <MenuList className={`px-4 pb-6`}>
                {allowUserSubscription && !isDesktop && (
                  <MenuItem
                    _hover={{ bg: '#f7f7f7' }}
                    _expanded={{}}
                    _focus={{}}
                    p={0}
                    m={0}
                  >
                    <Box
                      onClick={() => {
                        onToggle();
                        onCloseDropdown();
                      }}
                      className="flex gap-3 w-full items-center border-b border-[#D5DBE2] py-4 z-[1000]"
                    >
                      <Box
                        w="22px"
                        h="22px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        color="brand.primary"
                      >
                        <ArrowUpIcon w="18px" h="18px" />
                      </Box>
                      <Text fontWeight={600} color="brand.primary">
                        Upgrade
                      </Text>
                    </Box>
                  </MenuItem>
                )}
                {loggedInUserType !== 'admin' && (
                  <MenuItem
                    _hover={{ bg: '#f7f7f7' }}
                    _expanded={{}}
                    _focus={{}}
                    p={0}
                    m={0}
                  >
                    <Box
                      onClick={viewDetails}
                      className="flex gap-3 w-full items-center border-b border-[#D5DBE2] py-4 z-[1000]"
                    >
                      <Image
                        h="22px"
                        w="22px"
                        src={ProfileIcon}
                        alt="dashboard-icon"
                      />
                      <Text>Profile</Text>
                    </Box>
                  </MenuItem>
                )}

                <MenuItem
                  _hover={{ bg: '#f7f7f7' }}
                  _expanded={{}}
                  _focus={{}}
                  p={0}
                  m={0}
                >
                  <Box
                    onClick={() => {
                      navigate('/account-settings');
                    }}
                    className="flex gap-3 w-full items-center border-b border-[#D5DBE2] py-4 z-[1000]"
                  >
                    <Image
                      h="22px"
                      w="22px"
                      src={SettingsIcon}
                      alt="dashboard-icon"
                    />
                    <Text>Settings</Text>
                  </Box>
                </MenuItem>

                {loggedInUserType !== 'admin' && (
                  <MenuItem
                    _hover={{ bg: '#f7f7f7' }}
                    _expanded={{}}
                    _focus={{}}
                    p={0}
                    m={0}
                  >
                    <Box
                      onClick={() => {
                        onOpenSubmitComplaintModal();
                      }}
                      className="flex gap-3 w-full items-center border-b border-[#D5DBE2] py-4 z-[1000]"
                    >
                      <Image
                        h="22px"
                        w="22px"
                        src={MessageIcon}
                        alt="dashboard-icon"
                      />
                      <Text>Contact Support</Text>
                    </Box>
                  </MenuItem>
                )}

                <MenuItem
                  _hover={{ bg: '#f7f7f7' }}
                  _expanded={{}}
                  _focus={{}}
                  p={0}
                  m={0}
                >
                  <Box
                    onClick={onToggleLogoutModal}
                    className="flex gap-3 w-full items-center py-4"
                  >
                    <Image
                      h="22px"
                      w="22px"
                      src={LogoutIcon}
                      alt="dashboard-icon"
                    />
                    <Text>Logout</Text>
                  </Box>
                </MenuItem>
              </MenuList>
            </Menu>
          </>
        </Flex>
      </Flex>
      <Modal
        isOpen={isOpen}
        onClose={() => closePlanModal()}
        isCentered
        size={isDesktop ? '5xl' : 'full'}
        scrollBehavior="inside"
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent
          mx={isDesktop ? 0 : 0}
          my={isDesktop ? 0 : 0}
          maxH={isDesktop ? '90vh' : '100vh'}
          borderRadius={isDesktop ? 'md' : '0'}
          maxW={{ base: '100vw', sm: '95vw', md: '90vw', lg: '85vw', xl: '80vw', '2xl': '75vw' }}
        >
          <ModalCloseButton zIndex={10} />
          <ModalBody
            px={isDesktop ? 6 : 4}
            py={isDesktop ? 6 : 4}
            overflowY="auto"
            overflowX="hidden"
          >
            {page === 0 && (
              <Plans
                subscriptionPlans={subscriptionPlans}
                loggedInUserSubscription={loggedInUserSubscription}
                isDesktop={isDesktop}
                onUpgrade={upgradeUser}
                isCancelling={isCancelling}
                isResuming={isResuming}
                onCancel={handleCancelClick}
                onResume={handleResumeSubscription}
                userType={loggedInUserType}
              />
            )}
            {page === 1 && (
              <SelectedPlan
                selectedPlan={selectedPlan}
                selectedPackage={selectedPackage}
                isDesktop={isDesktop}
                onSelectPackage={selectPackage}
                onCheckout={checkout}
                isLoading={isCheckingSubscriptionPlan}
                onBack={() => setPage(0)}
                userType={loggedInUserType}
              />
            )}
            {page === 2 && <ThankYouPage onCancel={closePlanModal} planName={subscriptionPlans?.data?.find(plan => plan?.name === planName)?.name} />}
            {page === 3 && (
              <PaymentFailedPage
                onCancel={closePlanModal}
                planName={selectedPlan?.name}
                onRetry={handleRetry}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
      <CustomerSupportModal
        isOpen={submitComplaintModalIsOpen}
        onClose={onCloseSubmitComplaintModal}
      />
      <LogoutModal isOpen={isLogoutModalOpen} onClose={onToggleLogoutModal} />
    </Box>
  );
};

export default Header;
